import BaseAPIService from './baseAPI';

// Trends Analysis Types
export interface GetTrendsRequest {
  topic: string;
  use_cache: boolean;
}

export interface TrendsResponse {
  data: {
    trending_keywords: string[];
    hashtags: string[];
    sentiment: string;
    related_topics: string[];
    news_trends: string[];
  };
  status: string;
  message: string;
}

export interface AnalyzeTrendRequest {
  trend_keyword: string;
  time_range: 'day' | 'week' | 'month' | 'year';
  region?: string;
}

export interface TrendAnalysisResponse {
  data: {
    trend_score: number;
    growth_rate: number;
    peak_time: string;
    related_keywords: string[];
    sentiment_analysis: {
      positive: number;
      neutral: number;
      negative: number;
    };
  };
  status: string;
  message: string;
}

export interface GenerateFromTrendRequest {
  trend_keyword: string;
  content_type: 'educational' | 'news_commentary' | 'opinion' | 'question';
  tone: 'professional' | 'casual' | 'enthusiastic' | 'analytical';
}

export interface GenerateFromTrendResponse {
  data: {
    content: string;
    trend_context: string;
    suggested_hashtags: string[];
  };
  status: string;
  message: string;
  saved_post_id?: string;
}

class TrendsAPIService extends BaseAPIService {
  constructor() {
    super();
  }

  async getTrends(request: GetTrendsRequest): Promise<TrendsResponse> {
    return this.post<TrendsResponse>('/trends/get-trends', request);
  }

  async analyzeTrend(request: AnalyzeTrendRequest): Promise<TrendAnalysisResponse> {
    return this.post<TrendAnalysisResponse>('/trends/analyze-trend', request);
  }

  async generateFromTrend(request: GenerateFromTrendRequest): Promise<GenerateFromTrendResponse> {
    return this.post<GenerateFromTrendResponse>('/trends/generate-from-trend', request);
  }

  async getTrendingHashtags(category?: string): Promise<{ data: Array<{ hashtag: string; count: number; growth: number }> }> {
    return this.get<{ data: Array<{ hashtag: string; count: number; growth: number }> }>(`/trends/hashtags${category ? `?category=${category}` : ''}`);
  }

  async getTopicTrends(topic: string): Promise<TrendsResponse> {
    return this.post<TrendsResponse>('/trends/topic-trends', { topic });
  }

  async getRegionalTrends(region: string): Promise<{ data: Array<{ keyword: string; volume: number; region: string }> }> {
    return this.get<{ data: Array<{ keyword: string; volume: number; region: string }> }>(`/trends/regional/${region}`);
  }
}

export const trendsAPI = new TrendsAPIService();
export default trendsAPI; 